<template>
	<div class="breadcrumbs">
		<v-card v-if="!solo" color="primary">
			<v-row no-gutters align="center">
				<v-breadcrumbs large :items="items">
					<template v-slot:divider>
						<v-icon color="white">mdi-chevron-right</v-icon>
					</template>
					<template v-slot:item="props">
						<v-breadcrumbs-item :to="props.item.to" link exact>
							<div class="white--text">{{props.item.text}}</div>
						</v-breadcrumbs-item>
					</template>
				</v-breadcrumbs>
				<v-spacer></v-spacer>
				<div class="pr-5">
					<template v-if="$store.getters.hasRole('terapeut') && !this.$store.getters.isExternalEntity">
						<v-badge color="red" right overlap :content="$store.getters.timersComplete" :value="$store.getters.timersComplete">
							<v-btn icon @click="openTimers">
								<v-icon color="white">mdi-timer-outline</v-icon>
							</v-btn>
						</v-badge>
						<v-snackbar
							v-model="snackbar"
							color="primary"
							multi-line
							right
							:timeout="3000"
							top
							absolute
							style="right: 0; top: 65px"
						>
							<v-list-item class="pa-0" @click="goToAppointment">
								<v-list-item-icon class="mr-3">
									<v-icon color="white">mdi-timer-sand</v-icon>
								</v-list-item-icon>
								<v-list-item-content class="white--text pa-0">
									<v-list-item-title class="text-subtitle-2">
										{{notificationTimer.minutes}}
										<translate v-if="notificationTimer.minutes > 1" key="minutes">Minutes</translate>
										<translate v-else key="minute">Minute</translate>
										<v-icon small color="white" class="ml-1">mdi-checkbox-marked-circle</v-icon>
									</v-list-item-title>
									<v-list-item-subtitle class="white--text pr-0 text-caption">
										<span
											v-if="notificationTimer.appointment"
											class="mx-2"
										>{{notificationTimer.appointment.patient_name}} - {{notificationTimer.appointment.location}}</span>
										<br />
										<span class="mx-2">{{notificationTimer.description}}</span>
									</v-list-item-subtitle>
									<span
										class="mx-2 text-caption"
										style="position: absolute; bottom: 0px; right: 0px"
									>{{notificationTimer.user_name}}</span>
								</v-list-item-content>
							</v-list-item>
						</v-snackbar>
						<v-dialog v-model="showChrono" max-width="65%">
							<v-card>
								<v-card-title class="title primary--text mb-2 secondary">
									<translate>Timers</translate>
								</v-card-title>
								<v-card-text>
									<v-row no-gutters class="mt-3">
										<v-col cols="12" sm="12">
											<p v-if="timers.length == 0" class="font-weight-thin ml-2" v-translate>No timers created.</p>
											<v-list v-else>
												<TimerItem
													v-for="timer in $store.getters.timers"
													:key="timer.id"
													:timer="timer"
													@remove-timer="removeTimer"
													@show-notification="showNotification"
												/>
											</v-list>
										</v-col>
										<v-col cols="12" sm="12">
											<v-btn small fab class="mb-3" color="primary" @click="showNewTimer = !showNewTimer" :disabled="!$store.getters.hasAnyModule">
												<v-icon>mdi-plus</v-icon>
											</v-btn>
										</v-col>
										<v-col v-if="showNewTimer" cols="12" sm="12">
											<v-form>
												<v-row no-gutters>
													<v-col cols="12" sm="3">
														<v-select
															v-model="timerType"
															:items="timerOptions"
															:label="$gettext('Type')"
															outlined
															color="primary"
															hide-details
															class="pr-1"
														></v-select>
													</v-col>
													<v-col cols="12" sm="3" v-if="timerType == 'timer'" class="px-2">
														<v-text-field
															v-model="time"
															:label="$gettext('Minutes')"
															outlined
															hide-details
															prepend-icon="mdi-minus"
															append-outer-icon="mdi-plus"
															@click:prepend="time--"
															@click:append-outer="time++"
														/>
													</v-col>
													<v-col cols="12" sm="5">
														<v-text-field
															v-model="timerDescription"
															:label="$gettext('Description')"
															outlined
															hide-details
														/>
													</v-col>
													<v-col cols="12" sm="1" class="px-2">
														<v-btn small fab class="mt-2" color="primary" @click="addTimer">
															<v-icon>mdi-plus</v-icon>
														</v-btn>
													</v-col>
													<v-col cols="12" sm="12">
														<v-checkbox
															v-if="$route.params.aid"
															v-model="refAppointment"
															class="mt-1 text-caption--text"
															color="primary"
															:label="$gettext('Link to current appointment')"
															hide-details
														/>
													</v-col>
												</v-row>
											</v-form>
										</v-col>
									</v-row>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="primary darken-1" text @click="showChrono = false">
										<translate>Close</translate>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</template>
					<template v-if="cart && $store.getters.numItems > 0">
						<v-badge color="red" right overlap :content="$store.getters.numItems" :value="$store.getters.numItems">
							<v-btn text icon :to="{name: 'cart'}">
								<v-icon color="white">mdi-cart</v-icon>
							</v-btn>
						</v-badge>
					</template>
				</div>
			</v-row>
		</v-card>
		<v-breadcrumbs v-else large :items="items">
			<template v-slot:divider>
				<v-icon color="white">mdi-chevron-right</v-icon>
			</template>
			<template v-slot:item="props">
				<v-breadcrumbs-item :to="props.item.to" link exact>
					<div class="white--text">{{props.item.text}}</div>
				</v-breadcrumbs-item>
			</template>
		</v-breadcrumbs>
	</div>
</template>

<script>
import TimerItem from "@/components/timer/TimerItem.vue";
import axios from "axios";

export default {
	name: "Breadcrumbs",
	props: {
		items: {
			default: []
		},
		solo: {
			default: false
		},
		cart: {
			default: false
		}
	},
	components: {
		TimerItem
	},
	data: () => ({
		showChrono: false,
		showNewTimer: false,
		refAppointment: false,
		timerType: "timer",
		timerDescription: "",
		time: 5,
		snackbar: false,
		notificationTimer: {
			appointment: { patient_name: "", location: "" },
			description: ""
		}
	}),
	computed: {
		timers() {
			return this.$store.getters.timers;
		},
		timerOptions() {
			return [
				{ value: "timer", text: this.$gettext("Timer") },
				{ value: "chrono", text: this.$gettext("Chronometer") }
			];
		},
		cartNotifIcon() {
			return "mdi-numeric-" + this.$store.getters.numItems;
		}
	},
	methods: {
		showNotification(timer) {
			this.notificationTimer = timer;
			this.snackbar = true;
		},
		goToAppointment() {
			if (
				this.notificationTimer.appointment &&
				this.$store.getters.userId == this.notificationTimer.user_id
			) {
				this.snackbar = false;
				this.$route.push({
					name: "appointment",
					params: {
						pid: this.notificationTimer.appointment.patient_id,
						aid: this.notificationTimer.appointment.id
					}
				});
			} else {
				this.snackbar = false;
			}
		},
		openTimers() {
			axios
				.get("/api/timers")
				.then(response => {
					console.log(response.data);
					this.$store.dispatch("SET_TIMERS", response.data.timers);
					this.showChrono = true;
					if (this.$store.getters.timersComplete > 0)
						this.$store.dispatch("CLEAR_TIMER_NOTIFICATIONS");
				})
				.catch(error => console.log(error));
		},
		addTimer() {
			const formData = new FormData();
			if (this.timerType == "timer") {
				formData.append("minutes", this.time);
			}
			if (this.refAppointment) {
				formData.append("appointment_id", this.$route.params.aid);
			}
			formData.append("description", this.timerDescription);
			axios
				.post("/api/timers", formData)
				.then(response => {
					console.log(response.data);
					this.$store.dispatch("SET_TIMERS", response.data.timers);
					this.showNewTimer = false;
				})
				.catch(error => console.log(error));
		},
		removeTimer(timer) {
			axios
				.post("/api/timers/" + timer.id + "/delete")
				.then(response => {
					console.log(response.data);
					this.$store.dispatch("SET_TIMERS", response.data.timers);
				})
				.catch(error => console.log(error));
		}
	}
};
</script>